(() => {
  // Ne pas activer le smooth scroll dans l'éditeur Shopify
  if (window.Shopify && window.Shopify.designMode) return;

  // Respecter le réglage d'accessibilité "réduire les animations"
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Vérifier que Lenis est bien chargé
  if (!window.Lenis) {
    console.warn('Lenis n’a pas été chargé.');
    return;
  }

  const lenis = new Lenis({
    lerp: 0.08,
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 1,
    anchors: true
  });

  // Animation du scroll
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  // On garde Lenis accessible pour nos futures animations GSAP
  window.fullstackLenis = lenis;


  // Curseur personnalisé sur la bannière de cookies Shopify
  const applyCookieCursor = () => {
    const cookieDialog = document.querySelector(
      '.shopify-pc__banner__dialog'
    );

    if (cookieDialog) {
      cookieDialog.setAttribute('data-cursor', 'light');
    }
  };

  applyCookieCursor();

  // Shopify peut injecter la bannière après le chargement
  const cookieObserver = new MutationObserver(applyCookieCursor);

  cookieObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();